
import { DiscordIcon, InstagramIcon, RedditIcon } from "./icons";

export default function Footer() {
  return (
    <>
      <footer className="bg-white dark:bg-zinc-800">
        <div className="max-w-screen-xl p-4 py-6 mx-auto lg:py-16 md:p-8 lg:p-10">
          <div className="grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-3">
            <div>
              <h3 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
                Features
              </h3>
              <ul className="text-gray-500 dark:text-gray-400">
                <li className="mb-4">
                  <a href="/sync-playlists" className=" hover:underline">
                    Sync
                  </a>
                </li>
                <li className="mb-4">
                  <a href="/transfer-playlists-and-songs" className="hover:underline">
                    Transfer
                  </a>
                </li>
                <li className="mb-4">
                  <a href="/blog" className="hover:underline">
                    Blog
                  </a>
                </li>
                <li className="mb-4">
                  <a href="/faq" className="hover:underline">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
                Help center
              </h3>
              <ul className="text-gray-500 dark:text-gray-400">
                <li className="mb-4">
                  <a href="/contact-us" className="hover:underline">
                    Contact us
                  </a>
                </li>
                <li className="mb-4">
                  <a href="https://www.reddit.com/r/MusicPorter/" className="hover:underline">
                    Reddit
                  </a>
                </li>
                <li className="mb-4">
                  <a href="https://www.instagram.com/musicporter_app/" className="hover:underline">
                    Instagram
                  </a>
                </li>
                <li className="mb-4">
                  <a href="mailto:hello@musicporter.com" className="hover:underline">
                    hello@musicporter.com
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
                Legal
              </h3>
              <ul className="text-gray-500 dark:text-gray-400">
                <li className="mb-4">
                  <a href="/privacy-and-terms" className="hover:underline">
                    Privacy Policy & Terms
                  </a>
                </li>
              </ul>
            </div>

          </div>

          <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />

          <div className="text-center">
            <a
              href="/"
              className="flex items-center justify-center mb-5 text-2xl font-semibold text-gray-900 dark:text-white"
            >
              <img
                src={require("../../assets/logo.png")}
                className="h-6 sm:h-9"
                alt="Music Porter"
              />
            </a>
            <span className="block text-sm text-center text-gray-500 dark:text-gray-400 mb-5">
              © 2025. All Rights Reserved.
            </span>
            <span className="block text-sm text-center text-gray-500 dark:text-gray-400 mb-5">
              <img src={require("../../assets/made-in-canada-seeklogo.png")} className="mx-auto w-64" alt="Music Porter - made in Canada"></img>
            </span>
            <ul className="flex justify-center mt-5 space-x-5">
              <li>
                <a
                  href="https://discord.gg/6T35Rj74"
                  className="text-gray-500 hover:text-gray-900 dark:hover:text-white dark:text-gray-400"
                  aria-label="Music Porter at Discord"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <DiscordIcon />
                </a>
              </li>
              <li>
                <a
                  href="https://www.reddit.com/r/MusicPorter/"
                  className="text-gray-500 hover:text-gray-900 dark:hover:text-white dark:text-gray-400"
                  aria-label="Music Porter at Reddit"
                >
                  <RedditIcon />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/musicporter_app/"
                  className="text-gray-500 hover:text-gray-900 dark:hover:text-white dark:text-gray-400"
                  aria-label="Music Porter at Instagram"
                >
                  <InstagramIcon />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  )
}